import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ViewAllCourses() {
    const moment = extendMoment(Moment);
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "nv_courses"));
                const courseData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCourses(courseData);
            } catch (error) {
                console.error("Error fetching courses:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);




    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    <h6 className="mb-2">All Course</h6>

                </div>



                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Course ID</th>
                                <th>Name</th>
                                <th>Course Categories</th>
                                <th>Course Type</th>
                                <th>Start Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courses.map(course => (
                                <tr key={course.id}>
                                    <td>{course.course_id}</td>
                                    <td>{course.course_name}</td>
                                    <td>{course.course_categories || "N/A"}</td>
                                    <td>{course.course_type || "N/A"}</td>
                                    <td>{course.course_start_date || "N/A"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default ViewAllCourses;

